import '../sass/styles.scss';
require('../images/IG-LARP-Logo-gefuellt.png');
require('../images/gallery-video.svg');
import Gallery from './modules/gallery-slider';
require('./modules/FileInput');
import ConmanagerDetails from "./modules/ConmanagerDetails";
import NavSteps from './modules/NavSteps';


new Gallery();
let conmanagerDetails = new ConmanagerDetails();
conmanagerDetails.observeStickyRegisterButton('.material-button-wrapper');

$('.nav-steps-wrapper').each(function(index, element) {
    new NavSteps($(element));
});
//Featured Slick Slider
$(".featured").slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    touchMove: false,
    autoplay: false,
    autoplaySpeed: 5000,
    adaptiveHeight: true
});

// .main is positioned relative to create the floating look with header and footer and box-shadow. Modals that are
// placed inside .main are then positioned behind the backdrop, which is added just before the closing body tag.
// As header and footer should not have a z-index=-1, because they cannot be clicked anymore, the workaround is to
// move all modals to the document root leven with javascript.
$('.modal').appendTo('body');